import type { PolicyViewModel } from '@/api/types/PolicyViewModel';

import { useParams } from 'react-router';

import { usePolicyById } from 'src/api/hooks/usePolicyQueries';

type UsePolicyDataReturn = {
  viewPolicy?: PolicyViewModel;
  policyId: number;
  isLoading: boolean;
};

export function usePolicyDataFromParams(): UsePolicyDataReturn {
  const { comboId, coverageId, policyId } = useParams<{
    comboId: string;
    coverageId: string;
    policyId: string;
  }>();

  return usePolicyData({
    comboId: Number(comboId),
    coverageId: Number(coverageId),
    policyId: Number(policyId),
  });
}

export function usePolicyData({
  comboId,
  coverageId,
  policyId,
}: {
  comboId: number;
  coverageId: number;
  policyId: number;
}): UsePolicyDataReturn {
  const {
    data: viewPolicyData,
    isSuccess,
    isError,
    error,
    isLoading,
  } = usePolicyById(comboId, coverageId, policyId);

  if (isError) {
    // Any components that use this hook shouldn't even
    // be getting rendered if it wasn't loaded yet.
    throw error;
  }

  if (isLoading || !isSuccess) {
    return { policyId, isLoading };
  }

  return { policyId, viewPolicy: viewPolicyData.data, isLoading: false };
}
